import axios from "axios";

const baseUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:5000";
  } else if (process.env.NODE_ENV === "production") {
    return "/";
  }
};

const API = axios.create({
  baseURL: baseUrl(),
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

// It helps to send Token through headers
API.interceptors.request.use((req) => {
  if (localStorage?.getItem("afhnew")) {
    req.headers["Authorization"] = `Bearer ${localStorage.getItem("afhnew")}`;
  }
  return req;
});

// Auth Api
export const SignUp = (data) => API.post("/api/auth/SignUp", data);
export const SignIn = (data) => API.post("/api/auth/SignIn", data);

// filter api USER
export const HomeListFilter = (data) => API.post("/user/filter", data);
export const ContactUs = (data) => API.post("/user/contactUs", data);
export const AddWishList = (data) => API.post("/user/addWishlist", data);
export const CheckAvaliblity = (data) =>
  API.post("/user/checkAvaliblity", data);
export const GetNearByHomes = (data) => API.post("/user/getNearByHomes", data);
export const GetReviewsByHomeId = (data) => API.post("/user/getReviewsByHomeId", data);
export const addReview = (data) => API.post(`/user/addReview`,data);
export const editProfile = (data) => API.post(`/user/editProfile`,data);

// get api
export const GetHomeById = (data) => API.get(`/user/getHomeById/${data}`);
export const getCityNames = (data) => API.get(`/user/getCityNames/${data}`);
export const getWishlist = (data) => API.get(`/user/getWishlist`);


export const MarkerMapList = (data) => API.get(`/user/getAllLocations`);
